// extracted by mini-css-extract-plugin
export default {"root":"style_root__amA2R","head":"style_head__z7Ajq","title":"style_title__HA9Ql","all":"style_all__GIpZP","list":"style_list__wc0ZA","empty":"style_empty__2iijm"};